import { useState } from "react";
import { Lock } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

function ProtectFields({ values, onChange, tk }) {
  const [mismatch, setMismatch] = useState(false);

  const handleConfirm = (v) => {
    const updated = { ...values, confirm: v };
    setMismatch(v.length > 0 && v !== values.password);
    onChange(updated);
  };

  const handlePassword = (v) => {
    const updated = { ...values, password: v };
    setMismatch(values.confirm?.length > 0 && values.confirm !== v);
    onChange(updated);
  };

  return (
    <div className="p-5 bg-slate-50 rounded-xl border border-slate-200 space-y-4">
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1.5">{tk.passwordLabel}</label>
        <input
          type="password"
          value={values.password || ""}
          onChange={(e) => handlePassword(e.target.value)}
          placeholder={tk.passwordPlaceholder}
          data-testid="password-input"
          className="w-full px-4 py-2.5 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1.5">{tk.confirmLabel}</label>
        <input
          type="password"
          value={values.confirm || ""}
          onChange={(e) => handleConfirm(e.target.value)}
          placeholder={tk.confirmPlaceholder}
          data-testid="confirm-password-input"
          className={`w-full px-4 py-2.5 rounded-lg border text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white ${mismatch ? "border-red-400" : "border-slate-200"}`}
        />
        {mismatch && <p className="text-xs text-red-600 mt-1">{tk.passwordMismatch}</p>}
      </div>
    </div>
  );
}

export default function ProtectPDF() {
  const { t } = useLanguage();
  const tk = t.tools.protect;


  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/pdf/protect",
    accept: ".pdf",
    multiple: false,
    resultType: "download",
    resultFileName: tk.result,
    color: "#0f766e",
    Icon: Lock,
    toolKey: "protect",
    canProcessOverride: (files, values) =>
      files.length > 0 && values.password?.length > 0 && values.password === values.confirm,
    extraFields: ({ values, onChange }) => (
      <ProtectFields values={values} onChange={onChange} tk={tk} />
    ),
  };

  return <ToolPage config={config} />;
}
